import BootstrapData from '../models/BootstrapData';
import _ from 'underscore';
import {getQueryParamName} from '../../../client/scripts/selectors/AgendaSelectors';
import {FILTERS_NAMES} from 'web-common/scripts/constants/Agenda';

export const fetchMarkerData = (markerType, entityType, context, nonBooleanValueFieldName) => {
    // Check if undefined because if this true or false we dont want to get the data from the bootstrap data
    if (typeof context.model.get('markersData')[markerType] === 'undefined') {
        const boostrapDataMarkers = BootstrapData('bootstrap-data-markers');
        if (!_.isEmpty(boostrapDataMarkers)) {
            // If the bootstrap data contains data - set the model to this data
            const markerInServer = boostrapDataMarkers && boostrapDataMarkers.find(marker =>
                marker.entityId === context.model.get('id') &&
                marker.markerType === markerType &&
                marker.entity === entityType
            );
            let valueToSetInModel;
            if (nonBooleanValueFieldName) {
                valueToSetInModel = markerInServer ? markerInServer[nonBooleanValueFieldName] : undefined;
            } else {
                valueToSetInModel = !!markerInServer;
            }
            context.model.get('markersData')[markerType] = valueToSetInModel;
        } else {
            // If the bootstrap data does not contains data - set the model to false
            context.model.get('markersData')[markerType] = false;
        }
    }
};

export const getScreenWidth = () => {
    const isClientSideRendered = typeof document !== 'undefined' && typeof window !== 'undefined';
    if ( isClientSideRendered ) {
        return Math.max(document && document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return false;
};


export const queryInstanceToPostData = (instance, filtersToOmit = []) => {
    const singleValueFilters = [
        'count',
        'offset',
        'registration',
        'sort',
        'q',
        'sort',
        'sortOrder',
        'startTime',
        'endTime',
    ];

    const postData = {};
    const addNewField = (value, isSingleValueFilter) => isSingleValueFilter ? value: [value];
    const updateExistingField = (value, isSingleValueFilter, existingArray) => {
        if (isSingleValueFilter) {
            return value;
        }
        if (!isSingleValueFilter && existingArray) {
            existingArray.push(value);
            return existingArray;
        }
    };
    instance.map(({key, value})=> {
        const paramName = getQueryParamName(FILTERS_NAMES, key);
        if (filtersToOmit.includes(paramName)) {
            return;
        }
        const isSingleValueFilter = singleValueFilters.includes(paramName);
        postData[paramName] = postData[paramName]
            ? updateExistingField(value, isSingleValueFilter, postData[paramName])
            : addNewField(value, isSingleValueFilter);
    });
    return postData;
};
